import React from 'react';
import BreadCardModule from 'components/BreadCardModule';
import WarningModal from 'components/WarningModal';
import {useDispatch, useSelector} from 'Provider';
import {getBreadSDKErrorStateSelector} from 'store/profile/profile.selectors';
import {ProfileActions} from 'store/profile';
import {PanelSeparator} from '@eCommerce/frontend-legacy-shared-library-native';
import {BreadApplicationState} from 'models/BreadSDK';

interface ConnectedBreadCardModuleProps {
  apply: () => Promise<void>;
  isLoading: boolean;
}

const ConnectedBreadCardModule: React.FC<ConnectedBreadCardModuleProps> = ({
  apply,
  isLoading,
}) => {
  const dispatch = useDispatch();
  const breadSDKErrorState = useSelector(getBreadSDKErrorStateSelector);

  return (
    <>
      <WarningModal
        isOpen={!!breadSDKErrorState}
        title={'Oops, something went wrong!'}
        onClose={() => dispatch(ProfileActions.setBreadSDKError(false))}
        body={'We’re sorry - we’ve encountered an error.  Please try again.'}
        primaryCTATitle={'Try Again'}
        onPrimaryPress={apply}
      />
      <BreadCardModule onPress={apply} loading={isLoading} />
      <PanelSeparator />
    </>
  );
};

export default ConnectedBreadCardModule;
